// SEO audit batch 3, Part 1 — public side of the Review collection + ReviewStats
// (both managed from /admin → Reviews). One request returns everything the
// site needs; `useReviews()` (components/site/reviews/ReviewsContext.jsx) makes
// it once per page load. Uses the native fetch on purpose: this module is in
// the shared shell (every page), and importing axios here would pull its 49 KB
// into the main bundle (SEO audit batch 3, Part 3 measurement).
import { SOCIAL_LINKS } from "@/data/company";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const MIN_REVIEWS_TO_SHOW = 3;

// Before the API answers (and in the prerendered HTML) only the Yelp profile is
// known — the same URL the footer icon uses. Everything else waits for ReviewStats.
const YELP_URL = (SOCIAL_LINKS.find((s) => s.id === "yelp") || {}).href || "";

export const EMPTY_STATS = {
  google_rating: null,
  google_count: null,
  google_profile_url: "",
  google_review_link: "",
  yelp_rating: null,
  yelp_count: null,
  yelp_url: YELP_URL,
  bbb_url: "",
  google_link: "",
  show_google_rating: false,
};

/** { reviews (newest first), count, min_to_show, stats } */
export const fetchPublicReviews = () =>
  fetch(`${API}/reviews`)
    .then((r) => (r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`))))
    .then((d) => ({
      reviews: Array.isArray(d?.reviews) ? d.reviews : [],
      count: Number.isFinite(d?.count) ? d.count : 0,
      minToShow: d?.min_to_show || MIN_REVIEWS_TO_SHOW,
      stats: { ...EMPTY_STATS, ...(d?.stats || {}) },
    }));

/** "4.9★ on Google (12 reviews)" — only when there is a count of 1+; never rounded up or combined. */
export const googleRatingLine = (stats) => {
  if (!stats || !(stats.google_count >= 1) || !stats.google_rating) return "";
  const rating = Number(stats.google_rating).toFixed(1).replace(/\.0$/, "");
  const n = stats.google_count;
  return `${rating}★ on Google (${n} ${n === 1 ? "review" : "reviews"})`;
};

/**
 * Reviews to feature on a page: the ones from `city` first (when given), then
 * featured ones, then the newest — never more than `count`.
 */
export const pickReviews = (reviews, { city = "", count = 3 } = {}) => {
  const norm = (s) => (s || "").trim().toLowerCase();
  const local = city ? reviews.filter((r) => norm(r.city) === norm(city)) : [];
  const featured = reviews.filter((r) => r.featured && !local.includes(r));
  const rest = reviews.filter((r) => !local.includes(r) && !featured.includes(r));
  return [...local, ...featured, ...rest].slice(0, count);
};
